import { Routes, Route} from "react-router-dom";
import PublicLayout from "../components/layouts/PublicLayout";
import PrivateLayout from "../components/layouts/PrivateLayout";
import ProtectedRouteGuard from "./ProtectedRouteGuard";
//import { isTokenValid } from "../utils/AuthUtils";
import BonDeComClientListPage from "../pages/BonDeComClientListPage";
import BonDeComClientDetailsEditPage from "../pages/BonDeComClientDetailsEditPage";
import DevisDetailsEditPage from "../pages/DevisDetailsEditPage";
import LoginPage from "../pages/LoginPage";
import HomePage from "../pages/HomePage";
import AchatPage from "../pages/AchatPage";
import BonDeComFournissuerListPage from "../pages/BonDeComFournisseurListPage";
import BonDeComFournissuerNewPage from "../pages/BonDeComFournisseurNewPage";
import ReceptionPage from "../pages/ReceptionPage";
import AttributionPage from "../pages/AttributionPage";
import GestionStockPage from "../pages/GestionStockPage";
import MandatListPage from "../pages/MandatListPage";
import MandatDetailsEditPage from "../pages/MandatDetailsEditPage";

import DevisListPage from "../pages/DevisListPage";
import DevisNewPage from "../pages/DevisNewPage";
import ClientListPage from "../pages/ClientListPage";
import ClientNewPage from "../pages/ClientNewPage";
import ClientDetailsEditPage from "../pages/ClientDeatilsEditPage";
import FournisseurListPage from "../pages/FournisseurListPage";
import FournisseurNewPage from "../pages/FournisseurNewPage";
import FournisseurDetailsEditPage from "../pages/FournisseurDetailsEditPage";
import ContactListPage from "../pages/ContactListPage";
import ContactNewPage from "../pages/ContactNewPage";
import ContactDetailsEditPage from "../pages/ContactDetailsEditPage";
import AdresseListLivClientPage from "../pages/AdresseListLivClientPage";
import DashboardParametresPage from "../pages/DashboardParametresPage";
import DashboardMaintenancePage from "../pages/DashboardMaintenancePage";
import TVAListPage from "../pages/TVAListPage";
import TVANewPage from "../pages/TVANewPage";
import TVADeatailsEditPage from "../pages/TVADetailsEditPage";
import AdresseListFournisseurPage from "../pages/AdresseListFournisseurPage";
import AdresseNewPage from "../pages/AdresseNewPage";
import AdresseDetailsEditPage from "../pages/AdresseDeatilsEditPage";
import ProduitDetailsEditPage from "../pages/ProduitDetailsEditPage";
import ProduitListPage from "../pages/ProduitListPage";
import ProduitNewPage from "../pages/ProduitNewPage";
import BonDeComFournisseurDetailsEditPage from "../pages/BonDeComFournisseurDetailsEditPage";
import ApiDocsPage from "../pages/ApiDocsPage";
import TVAStateListPage from '../pages/TVAStateListPage'; // Adaptez le chemin
import TVAStateNewPage from '../pages/TVAStateNewPage';
import TVAStateEditPage from '../pages/TVAStateEditPage';


export default function Main() {

  //const isAuthenticated = isTokenValid();
  const isAuthenticated = true;

  return (
    <Routes>

      {/* PUBLIC */}
      <Route element={<PublicLayout />}>
        <Route path="/login" element={<LoginPage />} />
      </Route>

      {/* PRIVATE */}
      <Route element={<ProtectedRouteGuard isAllowed={isAuthenticated} />}>
        <Route element={<PrivateLayout />}>
          <Route path="/home/:user_id" element={<HomePage />} />
          <Route path="/devis_edit/:devis_id" element={<DevisDetailsEditPage />} />
          <Route path="/devis_list" element={<DevisListPage />} />
          <Route path="/devis_new" element={<DevisNewPage />} />
          <Route path="/bon_com_client_list" element={<BonDeComClientListPage />} />
          <Route path="/bon_com_client_edit/:bon_com_client_id" element={<BonDeComClientDetailsEditPage />} />
          <Route path="/achat/:achat_id" element={<AchatPage />} />
          <Route path="/bon_com_fournisseur_list" element={<BonDeComFournissuerListPage />} />
          <Route path="/bon_com_fournisseur_edit/:bon_com_fournisseur_id" element={<BonDeComFournisseurDetailsEditPage />} />
          <Route path="/bon_com_fournisseur_new" element={<BonDeComFournissuerNewPage />} />
          
          <Route path="/gestion_stock" element={<GestionStockPage />} />
          <Route path="/client_list" element={<ClientListPage />} />
          <Route path="/client_new" element={<ClientNewPage />} />
          <Route path="/client_edit/:client_id" element={<ClientDetailsEditPage />} />
          <Route path="/contact_list" element={<ContactListPage />} />
          <Route path="/contact_new" element={<ContactNewPage />} />
          <Route path="/contact_edit/:contact_id" element={<ContactDetailsEditPage />} />
          <Route path="/adresse_list_liv_client" element={<AdresseListLivClientPage />} />
          <Route path="/fournisseur_list" element={<FournisseurListPage />} />
          <Route path="/fournisseur_new" element={<FournisseurNewPage />} />
          <Route path="/fournisseur_edit/:fournisseur_id" element={<FournisseurDetailsEditPage />} />
          <Route path="/adresse_list_fournisseur" element={<AdresseListFournisseurPage />} />
          <Route path="/adresse/new/:adressholdertype" element={<AdresseNewPage />} />
          <Route path="/adresse/edit/:type/:adresse_id" element={<AdresseDetailsEditPage />} />
          <Route path="/product_list" element={<ProduitListPage />} />
          <Route path="/product_new" element={<ProduitNewPage />} />
          <Route path="/product_edit/:product_id" element={<ProduitDetailsEditPage />} />
          <Route path="/mandat_list" element={<MandatListPage />} />
        
          <Route path="/mandat_edit/:mandat_id" element={<MandatDetailsEditPage />} />
          <Route path="/docs" element={<ApiDocsPage />} />

          <Route path="/reception/:reception_id" element={<ReceptionPage />} />
          <Route path="/attribution/:attribution_id" element={<AttributionPage />} />
          <Route path="/tva_edit/:tva_id" element={<TVADeatailsEditPage />} />
          <Route path="/tva_new" element={<TVANewPage />} />
          <Route path="/tva_list" element={<TVAListPage />} />
          <Route path="/dashboard_parametres" element={<DashboardParametresPage />} />
          <Route path="/dashboard_maintenance" element={<DashboardMaintenancePage />} />
          
          <Route path="/tva-state-list" element={<TVAStateListPage />} />
          <Route path="/tva-state-new" element={<TVAStateNewPage />} />
          <Route path="/tva-state-edit/:state_id" element={<TVAStateEditPage />} />
        
        </Route>
      </Route>

    </Routes>
  );
}
